import styled from 'styled-components';

export const StyledFilter = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
  padding: 15px 0 0 0;
  margin-bottom: 21px;

  .button-section-container {
    display: flex;
    gap: 10px;

    .button-section-wrapper {
      display: flex;
      column-gap: 10px;

      .mobile-button {
        display: none;
      }
    }
  }

  .ant-select,
  .ant-picker,
  .ant-input,
  .ant-btn {
    border-radius: 3px;
  }

  .ant-form-item-control-input-content {
    .ant-input-affix-wrapper {
      border-radius: 3px;
    }
    .ant-input-number {
      border-radius: 3px;
    }
  }

  .advanced_filter {
    border: 1px solid ${({ theme }) => theme.colorPrimarys};
    .anticon-down {
      font-size: 13px;
    }
    background-color: inherit;
  }

  .ant-form-item-label {
    padding: 0 0 0px !important;
  }

  .main-filter {
    background-color: ${({ theme }) => theme.filterBackground} !important;
    padding: 15px 20px;
    border-color: ${({ theme }) => theme.filterBorder};
    border-width: 0px 0px 1px 0px;
    border-style: solid;

    form {
      .horizontal-form {
        display: flex;
        flex-wrap: wrap;
        align-items: end;
        gap: 10px;

        .left-side {
          display: flex;
          align-items: end;
          gap: 10px;
        }

        .right-side {
          display: flex;
          align-items: end;
          gap: 10px;
        }

        .ant-form-item {
          margin: 0;
        }
      }
    }
  }

  .tag-list {
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 15px 20px;
    flex-wrap: wrap;
  }

  .tag-list svg {
    color: ${({ theme }) => theme.tagCloseColor};
  }

  .record-count {
    margin: 0;
    text-align: center;
    margin-left: auto;
    padding: 15px 20px;
    min-width: 225px;
  }

  .filter-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
`;
